export default __webpack_public_path__ + "static/media/luisTeamBorder.6700cbad.png";